import { User, UserPermissions } from 'entities/user';

export enum Types {
  AMPLIFY_SIGNED_IN = 'Authentication:AmplifySignedIn',
  DISABLE_MFA = 'Authentication:DisableMFA',
  POPULATE_USER = 'Authentication:PopulateUser',
  REFRESH_PREFERRED_MFA = 'Authentication:RefreshPreferredMFA',
  POPULATE_PERMISSIONS = 'Authentication:PopulatePermissions',
  SIGN_OUT = 'Authentication:SignOut',
  UPDATE_PREFERRED_MFA = 'Authentication:UpdatePreferredMFA',
}

export interface AmplifySignInAction {
  type: Types.AMPLIFY_SIGNED_IN;
}

export interface DisableMFAAction {
  type: Types.DISABLE_MFA;
}

export interface PopulateUserAction {
  type: Types.POPULATE_USER;
  payload: {
    user: User;
  };
}

export interface RefreshPreferredMFAAction {
  type: Types.REFRESH_PREFERRED_MFA;
}

export interface PopulatePermissionsActions {
  type: Types.POPULATE_PERMISSIONS;
  payload: {
    permissions: UserPermissions;
  };
}

interface SignOutAction {
  type: Types.SIGN_OUT;
}

export interface UpdatePreferredMFAAction {
  type: Types.UPDATE_PREFERRED_MFA;
  payload: {
    preferredMFA: string;
  };
}

export type Action =
  | AmplifySignInAction
  | DisableMFAAction
  | PopulateUserAction
  | PopulatePermissionsActions
  | RefreshPreferredMFAAction
  | SignOutAction
  | UpdatePreferredMFAAction;
